/* eslint-disable prettier/prettier */
import { defineMessages } from 'react-intl';

export default defineMessages({
  buttonLabel: {
    id: 'features.faqsPage.buttonLabel',
    defaultMessage: 'Faq',
    description: 'Label of the FAQ button',
  },
  title: {
    id: 'features.faqsPage.title',
    defaultMessage: 'Frequently Asked Questions',
    description: 'Title of the FAQ page',
  },
  subtitle: {
    id: 'features.faqsPage.subtitle',
    defaultMessage:
      'Di seguito potete trovare risposte riguardanti i prodotti finanziari e i concetti che ne sono alla base',
    description: 'Subtitle of the FAQ page',
  },
  userManual: {
    id: 'features.faqsPage.userManual',
    defaultMessage: 'Manuale utente',
    description:
      'User manual link label (located at the bottom of the FAQs page)',
  },
  faqWhatAreInvestmentServices: {
    id: 'features.faqsPage.faqWhatAreInvestmentServices',
    defaultMessage: 'Cosa sono i servizi di investimento?',
    description: 'Text for what are investment services question',
  },
  faqWhatAreInvestmentServicesAnswer: {
    id: 'features.faqsPage.faqWhatAreInvestmentServicesAnswer',
    defaultMessage:
      'I servizi di investimento sono attività, prestate da soggetti specifici, attraverso le quali possiamo impiegare, sotto varie forme, i nostri risparmi in attività finanziarie',
    description: 'Text for what are investment services answer',
  },
  faqWhichAreInvestmentServices: {
    id: 'features.faqsPage.faqWhichAreInvestmentServices',
    defaultMessage: 'Quali sono i servizi di investimento finanziari?',
    description: 'Text for which are investment services question',
  },
  faqWhichAreInvestmentServicesFirstAnswerTitle: {
    id: 'features.faqsPage.faqWhichAreInvestmentServicesFirstAnswerTitle',
    defaultMessage: 'Esecuzione di ordini per conto dei clienti',
    description: 'Text for which are investment services title first answer',
  },
  faqWhichAreInvestmentServicesFirstAnswerDescription: {
    id: 'features.faqsPage.faqWhichAreInvestmentServicesFirstAnswerDescription',
    defaultMessage:
      'L\'esecuzione di ordini per conto dei clienti è il servizio con cui l\'intermediario, su richiesta del cliente, acquista o vende i titoli nelle varie sedi di negoziazione.',
    description:
      'Text for which are investment services description first answer',
  },
  faqWhichAreInvestmentServicesSecondAnswerTitle: {
    id: 'features.faqsPage.faqWhichAreInvestmentServicesSecondAnswerTitle',
    defaultMessage: 'Negoziazione per conto proprio',
    description: 'Text for which are investment services title second answer',
  },
  faqWhichAreInvestmentServicesSecondAnswerDescription: {
    id: 'features.faqsPage.faqWhichAreInvestmentServicesSecondAnswerTitle',
    defaultMessage:
      'Per negoziazione per conto proprio si intende l\'attività con cui l\'intermediario, su richiesta del cliente, colloca strumenti finanziari di sua proprietà ovvero li acquista direttamente dal cliente stesso (comunemente, si dice che l\'intermediario opera in "contropartita diretta").',
    description:
      'Text for which are investment services description second answer',
  },
  faqWhichAreInvestmentServicesThirdAnswerTitle: {
    id: 'features.faqsPage.faqWhichAreInvestmentServicesThirdAnswerTitle',
    defaultMessage: 'Gestione di sistemi multilaterali di negoziazione',
    description: 'Text for which are investment services title third answer',
  },
  faqWhichAreInvestmentServicesThirdAnswerDescription: {
    id: 'features.faqsPage.faqWhichAreInvestmentServicesThirdAnswerDescription',
    defaultMessage:
      'La gestione di sistemi multilaterali di negoziazione consiste nella gestione di sistemi in cui, in base a regole predeterminate, si incontrano proposte di acquisto e vendita di titoli e si concludono contratti. Un sistema di negoziazione è quindi una sorta di mercato aperto ad una pluralità di operatori.',
    description:
      'Text for which are investment services description third answer',
  },
  faqWhichAreInvestmentServicesFourthAnswerTitle: {
    id: 'features.faqsPage.faqWhichAreInvestmentServicesFourthAnswerTitle',
    defaultMessage: 'Ricezione e trasmissione di ordini',
    description: 'Text for which are investment services title fourth answer',
  },
  faqWhichAreInvestmentServicesFourthAnswerDescription: {
    id: 'features.faqsPage.faqWhichAreInvestmentServicesFourthAnswerDescription',
    defaultMessage:
      'La ricezione e trasmissione di ordini è il servizio con cui l\'intermediario, ricevuto un ordine di acquisto o vendita dal cliente, invece di eseguirlo egli stesso, lo trasmette ad altro intermediario per la sua esecuzione.',
    description:
      'Text for which are investment services description fourth answer',
  },
  faqWhichAreInvestmentServicesFifthAnswerTitle: {
    id: 'features.faqsPage.faqWhichAreInvestmentServicesFifthAnswerTitle',
    defaultMessage:
      'Sottoscrizione e/o collocamento con o senza assunzione a fermo ovvero assunzione di garanzia nei confronti dell\'emittente',
    description: 'Text for which are investment services title fifth answer',
  },
  faqWhichAreInvestmentServicesFifthAnswerDescription: {
    id: 'features.faqsPage.faqWhichAreInvestmentServicesFifthAnswerDescription',
    defaultMessage:
      'La sottoscrizione e/o collocamento è quel servizio nel quale l\'intermediario, generalmente nell\'ambito di offerte al pubblico di strumenti finanziari, li "distribuisce" agli investitori.',
    description:
      'Text for which are investment services description fifth answer',
  },
  faqWhichAreInvestmentServicesSixthAnswerTitle: {
    id: 'features.faqsPage.faqWhichAreInvestmentServicesSixthAnswerTitle',
    defaultMessage: 'Gestione di portafogli',
    description: 'Text for which are investment services title sixth answer',
  },
  faqWhichAreInvestmentServicesSixthAnswerDescription: {
    id: 'features.faqsPage.faqWhichAreInvestmentServicesSixthAnswerDescription',
    defaultMessage:
      'Con la gestione di portafogli il cliente incarica l\'intermediario di gestirgli in tutto o in parte il proprio patrimonio in strumenti finanziari. Spetta all\'intermediario decidere come e quando acquistare o vendere titoli.',
    description:
      'Text for which are investment services description sixth answer',
  },
  faqWhichAreInvestmentServicesSeventhAnswerTitle: {
    id: 'features.faqsPage.faqWhichAreInvestmentServicesSeventhAnswerTitle',
    defaultMessage: 'Consulenza in materia di investimenti',
    description: 'Text for which are investment services title seventh answer',
  },
  faqWhichAreInvestmentServicesSeventhAnswerDescription: {
    id: 'features.faqsPage.faqWhichAreInvestmentServicesSeventhAnswerDescription',
    defaultMessage:
      'Con la consulenza in materia di investimenti l\'intermediario fornisce consigli o raccomandazioni relative ad una o più operazioni concernenti un determinato strumento finanziario. Caratteristica del servizio è che il consiglio o la raccomandazione siano personalizzati, ossia presentati come adatti al cliente o basati sulle caratteristiche del cliente stesso.',
    description:
      'Text for which are investment services description seventh answer',
  },
  faqInvestmentServicesProvider: {
    id: 'features.faqsPage.faqInvestmentServicesProvider',
    defaultMessage: 'Chi può prestare servizi di investimento?',
    description: 'Text for investment services provider question',
  },
  faqInvestmentServicesProviderAnswer: {
    id: 'features.faqsPage.faqInvestmentServicesProviderAnswer',
    defaultMessage:
      'I servizi di investimento possono essere prestati solo da soggetti dotati di una specifica autorizzazione rilasciata, a seconda dei casi, dalla Consob o dalla Banca d\'Italia. L\'autorizzazione può essere rilasciata a:',
    description: 'Text for investment services provider answer',
  },
  faqInvestmentServicesProviderFirstSubAnswerTitle: {
    id: 'features.faqsPage.faqInvestmentServicesProviderFirstSubAnswerTitle',
    defaultMessage: 'Società di intermediazione mobiliare (sim) italiane:',
    description: 'Text for investment services provider first sub answer title',
  },
  faqInvestmentServicesProviderFirstSubAnswerDescription: {
    id: 'features.faqsPage.faqInvestmentServicesProviderFirstSubAnswerDescription',
    defaultMessage:
      'possono essere autorizzate dalla Consob ad offrire tutti i servizi di investimento;',
    description:
      'Text for investment services provider first sub answer description',
  },
  faqInvestmentServicesProviderSecondSubAnswerTitle: {
    id: 'features.faqsPage.faqInvestmentServicesProviderSecondSubAnswerTitle',
    defaultMessage: 'Banche italiane:',
    description:
      'Text for investment services provider second sub answer title',
  },
  faqInvestmentServicesProviderSecondSubAnswerDescription: {
    id: 'features.faqsPage.faqInvestmentServicesProviderSecondSubAnswerDescription',
    defaultMessage:
      'possono essere autorizzate dalla Banca d\'Italia ad offrire tutti i servizi di investimento;',
    description:
      'Text for investment services provider second sub answer description',
  },
  faqInvestmentServicesProviderThirdSubAnswerTitle: {
    id: 'features.faqsPage.faqInvestmentServicesProviderThirdSubAnswerTitle',
    defaultMessage: 'Società di gestione del risparmio (sgr):',
    description: 'Text for investment services provider third sub answer title',
  },
  faqInvestmentServicesProviderThirdSubAnswerDescription: {
    id: 'features.faqsPage.faqInvestmentServicesProviderThirdSubAnswerDescription',
    defaultMessage:
      'possono essere autorizzate dalla Banca d\'Italia all\'esercizio dell\'attività di gestione di portafogli, dell\'attività di consulenza e di commercializzazione di fondi comuni o sicav;',
    description:
      'Text for investment services provider third sub answer description',
  },
  faqInvestmentServicesProviderFourthSubAnswerTitle: {
    id: 'features.faqsPage.faqInvestmentServicesProviderFourthSubAnswerTitle',
    defaultMessage:
      'Intermediari finanziari iscritti nell\'elenco previsto dall\'art. 107 del Testo unico bancario tenuto dalla Banca d\'Italia:',
    description:
      'Text for investment services provider fourth sub answer title',
  },
  faqInvestmentServicesProviderFourthSubAnswerDescription: {
    id: 'features.faqsPage.faqInvestmentServicesProviderFourthSubAnswerDescription',
    defaultMessage:
      'possono essere autorizzati alla negoziazione per conto proprio e all\'esecuzione degli ordini dei clienti (limitatamente agli strumenti finanziari derivati), nonchè al servizio di sottoscrizione o collocamento;',
    description:
      'Text for investment services provider fourth sub answer description',
  },
  faqInvestmentServicesProviderFifthSubAnswerTitle: {
    id: 'features.faqsPage.faqInvestmentServicesProviderFifthSubAnswerTitle',
    defaultMessage: 'Banche di Paesi comunitari:',
    description: 'Text for investment services provider fifth sub answer title',
  },
  faqInvestmentServicesProviderFifthSubAnswerDescription: {
    id: 'features.faqsPage.faqInvestmentServicesProviderFifthSubAnswerDescription',
    defaultMessage:
      'possono offrire in Italia i servizi per i quali sono state autorizzate dall\'autorità di vigilanza del Paese d\'origine;',
    description:
      'Text for investment services provider fifth sub answer description',
  },
  faqInvestmentServicesProviderSixthSubAnswerTitle: {
    id: 'features.faqsPage.faqInvestmentServicesProviderSixthSubAnswerTitle',
    defaultMessage: 'Imprese di investimento di Paesi comunitari:',
    description: 'Text for investment services provider sixth sub answer title',
  },
  faqInvestmentServicesProviderSixthSubAnswerDescription: {
    id: 'features.faqsPage.faqInvestmentServicesProviderSixthSubAnswerDescription',
    defaultMessage:
      'possono offrire in Italia i servizi per i quali sono state autorizzate dall\'autorità di vigilanza del Paese d\'origine;',
    description:
      'Text for investment services provider sixth sub answer description',
  },
  faqInvestmentServicesProviderSeventhSubAnswerTitle: {
    id: 'features.faqsPage.faqInvestmentServicesProviderSeventhSubAnswerDescription',
    defaultMessage: 'Imprese di investimento extra-comunitarie:',
    description:
      'Text for investment services provider seventh sub answer title',
  },
  faqInvestmentServicesProviderSeventhSubAnswerDescription: {
    id: 'features.faqsPage.faqInvestmentServicesProviderSeventhSubAnswerDescription',
    defaultMessage:
      'possono essere autorizzate dalla Consob ad offrire in Italia tutti i servizi di investimento;',
    description:
      'Text for investment services provider seventh sub answer description',
  },
  faqInvestmentServicesProviderEighthSubAnswerTitle: {
    id: 'features.faqsPage.faqInvestmentServicesProviderEighthSubAnswerTitle',
    defaultMessage: 'Banche extra-comunitarie:',
    description:
      'Text for investment services provider eighth sub answer title',
  },
  faqInvestmentServicesProviderEighthSubAnswerDescription: {
    id: 'features.faqsPage.faqInvestmentServicesProviderEighthSubAnswerDescription',
    defaultMessage:
      'possono essere autorizzate dalla Banca d\'Italia ad offrire in Italia tutti i servizi di investimento;',
    description:
      'Text for investment services provider eighth sub answer description',
  },
  faqInvestmentServicesProviderNinthSubAnswerTitle: {
    id: 'features.faqsPage.faqInvestmentServicesProviderNinthSubAnswerTitle',
    defaultMessage:
      'Agenti di cambio iscritti nel ruolo unico nazionale tenuto dal Ministero dell\'economia e delle finanze:',
    description: 'Text for investment services provider ninth sub answer title',
  },
  faqInvestmentServicesProviderNinthSubAnswerDescription: {
    id: 'features.faqsPage.faqInvestmentServicesProviderNinthSubAnswerDescription',
    defaultMessage:
      'possono svolgere l\'attività di esecuzione di ordini, collocamento, gestione di portafogli, ricezione e trasmissione di ordini e consulenza.',
    description:
      'Text for investment services provider ninth sub answer description',
  },
  faqWhatAreFinancialTools: {
    id: 'features.faqsPage.faqWhatAreFinancialTools',
    defaultMessage: 'Cosa sono gli strumenti finanziari?',
    description: 'Text for what are financial tools question',
  },
  faqWhatAreFinancialToolsAnswer: {
    id: 'features.faqsPage.faqWhatAreFinancialToolsAnswer',
    defaultMessage:
      'Con questo termine si intendono tutti quegli strumenti attraverso i quali è possibile effettuare investimenti di natura finanziaria.',
    description: 'Text for what are financial tools answer',
  },
  faqMostCommonFinancialTools: {
    id: 'features.faqsPage.faqMostCommonFinancialTools',
    defaultMessage: 'Quali sono gli strumenti finanziari più comuni?',
    description: 'Text for most common financial tools question',
  },
  faqMostCommonFinancialToolsFirstAnswer: {
    id: 'features.faqsPage.faqMostCommonFinancialToolsFirstAnswer',
    defaultMessage: 'Azioni',
    description: 'Text for most common financial tools first answer',
  },
  faqMostCommonFinancialToolsSecondAnswer: {
    id: 'features.faqsPage.faqMostCommonFinancialToolsSecondAnswer',
    defaultMessage: 'Obbligazioni',
    description: 'Text for most common financial tools second answer',
  },
  faqMostCommonFinancialToolsThirdAnswer: {
    id: 'features.faqsPage.faqMostCommonFinancialToolsThirdAnswer',
    defaultMessage: 'Titoli di Stato',
    description: 'Text for most common financial tools third answer',
  },
  faqMostCommonFinancialToolsFourthAnswer: {
    id: 'features.faqsPage.faqMostCommonFinancialToolsFourthAnswer',
    defaultMessage: 'Quote di fondi',
    description: 'Text for most common financial tools fourth answer',
  },
  faqMostCommonFinancialToolsFifthAnswer: {
    id: 'features.faqsPage.faqMostCommonFinancialToolsFifthAnswer',
    defaultMessage: 'Strumenti derivati',
    description: 'Text for most common financial tools fifth answer',
  },
  faqBenchmark: {
    id: 'features.faqsPage.faqBenchmark',
    defaultMessage: 'Cosa è il benchmark?',
    description: 'Text for benchmark question',
  },
  faqBenchmarkAnswer: {
    id: 'features.faqsPage.faqBenchmark',
    defaultMessage:
      'Il benchmark è il parametro di riferimento che in ambito economico e, in particolare, degli investimenti ha la funzione di permettere un confronto tra le performance del proprio portafoglio e l\'andamento del mercato.',
    description: 'Text for benchmark answer',
  },
  faqRating: {
    id: 'features.faqsPage.faqRating',
    defaultMessage: 'Cosa è il rating?',
    description: 'Text for rating question',
  },
  faqRatingAnswer: {
    id: 'features.faqsPage.faqRatingAnswer',
    defaultMessage:
      'Il rating è un giudizio che viene espresso da un soggetto esterno e indipendente, l\'agenzia di rating, sulle capacità di una società di pagare o meno i propri debiti. l\'agenzia di rating valuta la solvibilità di un soggetto emittente obbligazioni; in altri termini attribuisce un giudizio circa la capacità della stessa di generare le risorse necessarie a far fronte agli impegni presi nei confronti dei creditori. Tale giudizio è sottoposto a revisione periodica.',
    description: 'Text for rating answer',
  },
  faqInvestmentTimeHorizon: {
    id: 'features.faqsPage.faqInvestmentTimeHorizon',
    defaultMessage: 'Cosa è l\'orizzonte temporale di investimento?',
    description: 'Text for investment time horizon question',
  },
  faqInvestmentTimeHorizonAnswer: {
    id: 'features.faqsPage.faqInvestmentTimeHorizon',
    defaultMessage:
      'L\'orizzonte temporale di un investitore misura il massimo intervallo di tempo all\'interno del quale l\'investitore è in grado di non preoccuparsi delle oscillazioni di valore del proprio investimento',
    description: 'Text for investment time horizon answer',
  },
  faqPerformance: {
    id: 'features.faqsPage.faqPerformance',
    defaultMessage: 'Cosa è la performance?',
    description: 'Text for performance question',
  },
  faqPerformanceAnswer: {
    id: 'features.faqsPage.faqPerformance',
    defaultMessage:
      'La performance (o rendimento) è il risultato ottenuto dalla gestione di uno strumento finanziario in un determinato periodo di tempo.',
    description: 'Text for performance answer',
  },
  faqSwitch: {
    id: 'features.faqsPage.faqSwitch',
    defaultMessage: 'Cosa è lo switch?',
    description: 'Text for switch question',
  },
  faqSwitchAnswer: {
    id: 'features.faqsPage.faqSwitchAnswer',
    defaultMessage:
      'É il contestuale passaggio da un fondo comune di investimento ad un altro gestito dalla stessa società.',
    description: 'Text for switch answer',
  },
});
